import { usePageMeta } from "@/lib/seo";
import { Header } from "@/components/Header";
import { Footer } from "@/components/Footer";
import { Hero } from "@/components/landing/Hero";
import { HowItWorks, Features } from "@/components/landing/Sections";
import { DemoArea } from "@/components/landing/DemoArea";
import { Pricing } from "@/components/landing/Pricing";

export default function Landing() {
  usePageMeta({ title: null, description: "Get 3 smart, flirty replies to any chat screenshot in seconds. AI rizz assistant for Instagram, WhatsApp, Tinder & Hinge — 100+ languages incl. Hinglish. Free to start.", index: true });
  return (
    <div className="min-h-screen overflow-x-hidden" data-testid="landing-page">
      <Header landing />
      <main>
        <Hero />
        <HowItWorks />
        <Features />
        <DemoArea />
        <Pricing />
      </main>
      <Footer />
    </div>
  );
}
